import { env } from "~/env"

export const siteConfig = {
  name: "IoTSec Pulse",
  slug: "iotsecpulse",
  tagline: "Awesome IoT Security Insights",
  description:
    "One-stop hub for IoT security insights, analyses, tools and more.",
  email: env.NEXT_PUBLIC_SITE_EMAIL,
  url: env.NEXT_PUBLIC_SITE_URL,

  keywords: [
    "IoTSec Pulse",
    "awesome IoT security",
    "IoT security insights",

    "IoT security",
    "IoT vulnerability analysis",
    "IoT security tools",
    "IoT penetration testing",

    "security analyses",
    "security research",
    "cybersecurity insights"
  ],

  alphabet: "abcdefghijklmnopqrstuvwxyz",

  affiliateUrl: "",
}
